import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import getBemClassNames from '../helpers/getBemClassNames';

const propTypes = {
  tLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  variants: PropTypes.arrayOf(PropTypes.oneOf(['inverted', 'text', 'small', 'iconed'])),
};

const defaultProps = {
  type: 'button',
  className: '',
  variants: [],
};

function Button({ intl, tLabel, onClick, type, variants, className }) {
  const classes = classNames(className, getBemClassNames('Button', variants));

  return (
    <button className={classes} type={type} onClick={onClick}>
      {intl.formatMessage({ id: tLabel })}
    </button>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default injectIntl(Button);



// WEBPACK FOOTER //
// ./src/components/Button.js